import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chakra-ui/react'

BulletIcon.propTypes = {
  active: PropTypes.bool,
  indent: PropTypes.number,
}

export function BulletIcon({ active = false, indent = 0 }) {
  return (
    <Box
      position="absolute"
      zIndex={0}
      top={2}
      left={0 - (indent - 1) * 4}
    >
      <svg
        width={12}
        height={8}
        style={{ marginRight: 12 }}
      >
        <circle
          cx={4}
          cy={4}
          r={3}
          fill={active ? 'white' : '#2c5282'}
          stroke={`rgba(255, 255, 255, ${active ? 0.3 : 1})`}
        />
      </svg>
    </Box>
  )
}
